// extracted by mini-css-extract-plugin
module.exports = {"label":"label--2P5zq","additionalInfo":"additionalInfo--3JscX"};